export default __webpack_public_path__ + "static/media/email.7be6e02d.svg";